var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.166504 2.5C0.166504 1.39543 1.06193 0.5 2.1665 0.5H23.8332C24.9377 0.5 25.8332 1.39543 25.8332 2.5V19.5C25.8332 20.6046 24.9377 21.5 23.8332 21.5H2.1665C1.06193 21.5 0.166504 20.6046 0.166504 19.5V2.5ZM5.99984 9.83333C5.3555 9.83333 4.83317 10.3557 4.83317 11C4.83317 11.6443 5.3555 12.1667 5.99984 12.1667H10.6665C11.3108 12.1667 11.8332 11.6443 11.8332 11C11.8332 10.3557 11.3108 9.83333 10.6665 9.83333H5.99984ZM5.99984 14.5C5.3555 14.5 4.83317 15.0223 4.83317 15.6667C4.83317 16.311 5.3555 16.8333 5.99984 16.8333H19.9998C20.6442 16.8333 21.1665 16.311 21.1665 15.6667C21.1665 15.0223 20.6442 14.5 19.9998 14.5H5.99984ZM17.436 7.80969C17.9098 7.41858 18.5945 7.41858 19.0683 7.80969C19.9044 8.49987 21.1665 7.90515 21.1665 6.82098V4.83333C21.1665 3.72877 20.2711 2.83333 19.1665 2.83333H17.3378C16.2333 2.83333 15.3378 3.72876 15.3378 4.83333V6.82098C15.3378 7.90515 16.5999 8.49987 17.436 7.80969Z",
    fill: "#765FA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d3e97c1252f36017af4e5c71c4727b2a.svg";
export { ForwardRef as ReactComponent };